__turbopack_context__.v({
  "walletModal": "WalletModalProvider-module__fvhK4a__walletModal",
});
